import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }
const _hoisted_3 = { class: "sortable-links overflow-x-auto p-2 -m-2" }
const _hoisted_4 = { class: "flex w-full justify-end -m-1" }
const _hoisted_5 = { class: "flex items-center font-medium text-gray-700" }
const _hoisted_6 = { class: "min-w-0 break-words" }
const _hoisted_7 = { class: "break-words" }
const _hoisted_8 = { class: "draggable-invisible" }
const _hoisted_9 = { class: "flex justify-end align-center" }

import { Bars3Icon, XCircleIcon } from '@heroicons/vue/24/outline'
import { Sortable } from '@shopify/draggable'
import { computed, reactive, ref } from 'vue'

import NeueTablist from '@/components/neue/NeueTablist'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'LinksNeue',
  setup(__props) {

const linkCols = [{ width: 'minmax(140px, 1fr)' }, { width: 'minmax(180px, 2fr)' }, { width: '100px' }]

const canUpdateSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'update'))
const loading = ref(true)
const hasUnsavedChanges = ref(false)
const sortables = ref([])

const modal = reactive({
  open: false,
  text: '',
  url: '',
  elementId: null
})

const local = reactive({
  links: []
})

const globe = computed(() => mapType('page').find(x => x.attributes.type === 'GlobalPage'))
const modules = computed(() =>
  mapRelationships(globe.value?.relationships.page_modules.data).sort((a, b) => a.attributes.order - b.attributes.order)
)
const menu = computed(() => modules.value.find(x => x.attributes.type === 'MenuPageModule'))
const footer = computed(() => modules.value.find(x => x.attributes.type === 'FooterPageModule'))
const elements = mod => mapRelationships(mod.relationships.content_elements.data)

const openLinksModal = elementId => {
  if (!canUpdateSite.value) return
  modal.open = true
  modal.text = local.links.find(x => x.id === elementId)?.text
  modal.url = local.links.find(x => x.id === elementId)?.url
  modal.elementId = elementId
}

const saveLinksModal = () => {
  if (!canUpdateSite.value) return
  api
    .call('PUT', `pages/${globe.value.id}/page_modules/${menu.value.id}?included=content_elements`, {
      page_module: {
        content_elements_attributes: [
          {
            type: 'PageLinkContentElement',
            id: modal.elementId,
            primary_text: modal.text,
            url: modal.url
          }
        ]
      }
    })
    .then(setLocal)
  modal.open = false
}

const deleteLink = link => {
  if (!canUpdateSite.value) return
  api
    .call('PUT', `pages/${globe.value.id}/page_modules/${menu.value.id}?included=content_elements`, {
      page_module: {
        content_elements_attributes: [
          {
            id: link.id,
            _destroy: true
          }
        ]
      }
    })
    .then(setLocal)
}

const setLocal = () => {
  for (const mod of modules.value) {
    if (mod.attributes.type === 'MenuPageModule') {
      local.links = []
      const els = elements(mod)
      if (!els) continue
      local.links = els.map(el => ({
        id: el.id,
        text: el.attributes.primary_text,
        url: el.attributes.url
      }))
    }
  }
  hasUnsavedChanges.value = false
}

const save = () => {
  if (!canUpdateSite.value) return
  for (const mod of modules.value) {
    if (mod.attributes.type === 'MenuPageModule') {
      api.call('PUT', `pages/${globe.value.id}/page_modules/${mod.id}`, {
        page_module: {
          content_elements_attributes: local.links.map((link, i) => ({
            id: link.id,
            order: i
          }))
        }
      })
    }
  }
  hasUnsavedChanges.value = false
}

const initSortables = () => {
  for (const sortable of sortables.value) sortable.destroy()
  sortables.value = []

  if (canUpdateSite.value) {
    sortables.value.push(
      new Sortable(document.querySelectorAll('.sortable-links .tablist-body'), { handle: '.cursor-move' }).on(
        'sortable:stop',
        e => {
          if (!canUpdateSite.value) return
          if (e.data.oldIndex === e.data.newIndex) return
          const list = local.links
          const moved = list.splice(e.data.oldIndex, 1)[0]
          list.splice(e.data.newIndex, 0, moved)
          list.map((x, i) =>
            api.call('PUT', `pages/${globe.value.id}/page_modules/${menu.value.id}`, {
              page_module: {
                content_elements_attributes: [
                  {
                    id: x.id,
                    order: i
                  }
                ]
              }
            })
          )
        }
      )
    )
  }
}

api
  .call('GET', 'pages?included=page_modules,page_modules.content_elements')
  .then(setLocal)
  .then(initSortables)
  .then(() => {
    loading.value = false
  })

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_InputField = _resolveComponent("InputField")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: "Links menu",
        "save-status": true
      }),
      (canUpdateSite.value)
        ? (_openBlock(), _createBlock(_component_SaveBar, {
            key: 0,
            "has-unsaved-changes": hasUnsavedChanges.value,
            onOnDiscard: setLocal,
            onOnSave: save
          }, null, 8, ["has-unsaved-changes"]))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      _createVNode(_component_TheModal, {
        "is-open": modal.open,
        "modal-title": modal.elementId ? 'Edit link' : 'Add a link',
        onCloseModal: _cache[3] || (_cache[3] = $event => (modal.open = false))
      }, {
        main: _withCtx(() => [
          _createVNode(_component_FormSection, {
            onKeyup: _withKeys(saveLinksModal, ["enter"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: modal.text,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((modal.text) = $event)),
                    name: "Display text",
                    disabled: !canUpdateSite.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: modal.url,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.url) = $event)),
                    name: "URL",
                    disabled: !canUpdateSite.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: _cache[2] || (_cache[2] = $event => (modal.open = false))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          (canUpdateSite.value)
            ? (_openBlock(), _createBlock(_component_NeueButton, {
                key: 0,
                type: "primary",
                onClick: saveLinksModal
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Save", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-open", "modal-title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SettingsSection, {
                title: "Links menu",
                description: "The links in your storefront's menu, like your About page or a page on another site. Click a link to change its text or where it goes, or drag it by its handle to change the order.",
                plain: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(NeueTablist), null, {
                      head: _withCtx(() => [
                        _createVNode(_unref(TablistHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: linkCols,
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[9] || (_cache[9] = _createElementVNode("div", null, "Link text", -1)),
                                _cache[10] || (_cache[10] = _createElementVNode("div", null, "URL", -1)),
                                _createElementVNode("div", _hoisted_4, [
                                  (canUpdateSite.value)
                                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                                        key: 0,
                                        type: "secondary",
                                        onClick: _cache[4] || (_cache[4] = $event => (openLinksModal()))
                                      }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode(" + Link ", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(local.links, (link) => {
                          return (_openBlock(), _createBlock(_unref(TablistRow), {
                            key: link.id,
                            class: _normalizeClass(["draggable-source", canUpdateSite.value ? 'cursor-pointer' : 'cursor-not-allowed opacity-50']),
                            onClick: $event => (canUpdateSite.value && openLinksModal(link.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, {
                                columns: linkCols,
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["-ml-4 px-3 -mt-2 -mb-2 py-2", canUpdateSite.value ? 'cursor-move' : 'cursor-not-allowed opacity-50'])
                                    }, [
                                      _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                    ], 2),
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(link.text), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(link.url), 1),
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                      (canUpdateSite.value)
                                        ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                            key: 0,
                                            class: "cursor-pointer h-6 w-6 hover:text-black",
                                            onClick: _withModifiers($event => (deleteLink(link)), ["stop"])
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, local.links?.length]
                  ]),
                  (!local.links?.length)
                    ? (_openBlock(), _createBlock(_component_EmptyState, {
                        key: 0,
                        plural: "links",
                        class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                      }, {
                        default: _withCtx(() => [
                          (canUpdateSite.value)
                            ? (_openBlock(), _createBlock(_component_NeueButton, {
                                key: 0,
                                type: "primary",
                                onClick: _cache[5] || (_cache[5] = $event => (openLinksModal()))
                              }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("+ Link", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}